import journeyService from '@/services/journeyService'

const state = {
  journeys: [],
  selectedJourney: {},
  totalJourneys: 0,
  pagination: {}
}

const mutations = {
  'SET_JOURNEYS' (state, journeys) {
    state.journeys = journeys
  },
  'SET_JOURNEYS_PAGINATION' (state, pagination) {
    state.pagination = pagination
  },
  'SET_SELECTED_JOURNEY' (state, journey) {
    state.selectedJourney = journey
  },
  'SET_TOTAL_JOURNEYS' (state, totalJourneys) {
    state.totalJourneys = totalJourneys
  }
}

const actions = {
  async newJourney (vuexContext, { companyId, appId, data }) {
    const company = companyId || vuexContext.getters.companyUuid
    const app = appId || vuexContext.getters.appUuid
    await journeyService.newJourney(vuexContext.getters.token, company, app, data)
  },
  async getJourneys (vuexContext, { companyId, appId, search }) {
    const company = companyId || vuexContext.getters.companyUuid
    const app = appId || vuexContext.getters.appUuid
    const pagination = vuexContext.state.pagination
    try {
      const response = await journeyService.getJourneys(vuexContext.getters.token, company, app, pagination, search)
      vuexContext.commit('SET_JOURNEYS', response.journeys.rows)
      vuexContext.commit('SET_TOTAL_JOURNEYS', response.journeys.count)
      return true
    } catch (e) {
      vuexContext.commit('SET_JOURNEYS', [])
      vuexContext.commit('SET_TOTAL_JOURNEYS', 0)
      throw e
    }
  },
  async getJourney (vuexContext, { companyId, appId, journeyId }) {
    const company = companyId || vuexContext.getters.companyUuid
    const app = appId || vuexContext.getters.appUuid
    try {
      const response = await journeyService.getJourney(vuexContext.getters.token, company, app, journeyId)
      vuexContext.commit('SET_SELECTED_JOURNEY', response.journey)
      return true
    } catch (e) {
      vuexContext.commit('SET_SELECTED_JOURNEY', {})
      throw e
    }
  },
  async deleteJourney (vuexContext, { companyId, appId, journeyId }) {
    const company = companyId || vuexContext.getters.companyUuid
    const app = appId || vuexContext.getters.appUuid
    await journeyService.deleteJourney(vuexContext.getters.token, company, app, journeyId)
    return true
  },
  async deleteDependsOn (vuexContext, { companyId, appId, journeyId, dependsOn }) {
    const company = companyId || vuexContext.getters.companyUuid
    const app = appId || vuexContext.getters.appUuid
    await journeyService.deleteDependsOn(vuexContext.getters.token, company, app, journeyId, dependsOn)
    return true
  },
  async updateDependsOn (vuexContext, { companyId, appId, journeyId, dependsOn }) {
    const company = companyId || vuexContext.getters.companyUuid
    const app = appId || vuexContext.getters.appUuid
    await journeyService.updateDependsOn(vuexContext.getters.token, company, app, journeyId, dependsOn)
    return true
  },
  async updateJourney (vuexContext, { companyId, appId, journeyId, data }) {
    const company = companyId || vuexContext.getters.companyUuid
    const app = appId || vuexContext.getters.appUuid
    await journeyService.updateJourney(vuexContext.getters.token, company, app, journeyId, data)
  }
}

const getters = {
  journeysIds (state) {
    const ids = state.journeys.map(item => ({ id: item.id, name: item.name }))
    return ids || []
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}
